import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { RegularRowComponent } from './regular-row.component';
import { FormsModule } from '@angular/forms';
import { QuestionModule } from '../question/question.module';
import { PhoneNumberModule } from '@schoolbelle/common/phone-number';
import { OptionNumberModule, OptionTextModule, OptionAfterschoolModule } from '../options';

@NgModule({
  declarations: [RegularRowComponent],
  imports: [
    CommonModule,
    FormsModule,
    BsDropdownModule.forRoot(),
    QuestionModule,
    OptionNumberModule,
    OptionAfterschoolModule,
    OptionTextModule,
    PhoneNumberModule.forRoot(),
  ],
  exports: [RegularRowComponent]
})
export class RegularRowModule {}
